import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { tpoGenUrls } from 'config/urls';
import { tpoGenKeys } from '../../../utils/tpoGenQueryKeys';
import { sendNotification } from 'utils/helperMethods';

const deletePromo = async (promotionId: string) => {
    const token = localStorage.getItem('accessToken');
    const response = await axios(tpoGenUrls.deletePromo(promotionId), {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
};

const useDeletePromoMutation = ({
    eventId,
    onSuccess,
}: {
    eventId: string;
    onSuccess?: (deletedPromoId: string) => void;
} = { eventId: '' }) => {
    const queryClient = useQueryClient();

    const { mutate, isPending } = useMutation({
        mutationFn: (promotionId: string) => deletePromo(promotionId),
        onSuccess: (_data, promotionId) => {
            queryClient.invalidateQueries({ queryKey: tpoGenKeys.all });
            if (eventId) {
                queryClient.invalidateQueries({ queryKey: tpoGenKeys.eventDetails(eventId) });
            }
            sendNotification('success', 'Promo deleted successfully');
            onSuccess?.(promotionId);
        },
        onError: (error: any) => {
            const message = error?.response?.data?.message || error?.message || 'Failed to delete promo';
            sendNotification('error', message);
        },
    });

    return { mutate, isPending };
};

export default useDeletePromoMutation;
